(function($) {
    $(document).ready(function () {

        form_states();

        $( document ).ajaxComplete(function( event, request, settings ) {
            form_states();


            var text=$('footer .form-with-content div[role="alert"]').clone().children().remove().end().text();


            var child=$('footer .form-with-content div[role="alert"]').children();
            $('footer .form-with-content div[role="alert"]').html(child);
            $('footer .form-with-content div[role="alert"]').append('<ul><li>'+text+'</li></ul>');

            var child=$('footer .form-with-content div[role="contentinfo"]').children();
            $('footer .form-with-content div[role="contentinfo"]').html(child);

        });


        function form_states() {

            $('footer .form-with-content .js-form-item input').focus(function () {
                $(this).parent().addClass("selected-state");
            });
            $('footer .form-with-content .js-form-item input').blur(function(){
                $(this).parent().removeClass("selected-state");
            });

            $('footer .form-with-content .js-form-item').on('blur', 'input', function () {
                if ($(this).val()) {
                    $(this).parent().addClass('used');
                }
                else {
                    $(this).parent().removeClass('used');
                }
            });
        }


    });
})(jQuery);